document.addEventListener("DOMContentLoaded", function () {
  // Function to check wishlist state
  function checkWishlistState(button) {
    const customerId = button.getAttribute("data-customer");
    const productId = button.getAttribute("data-product");
    
    if (!customerId || !productId) return;

    fetch("https://apps.gemstonesforsale.com/wp-json/wishlist/v1/contains", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        customer_id: customerId,
        product_id: productId
      })
    })
      .then(res => res.json())
      .then(data => {
        if (data.status === true) {
          button.classList.add("in");
        } else {
          button.classList.remove("in");
        }
      })
      .catch(err => {
        console.error("Wishlist check error:", err);
      });
  }

  // Run check on all buttons available at load
  document.querySelectorAll(".wishlist_button").forEach(checkWishlistState);

    // Handle clicks with delegation
    document.addEventListener("click", async function (e) {
    const button = e.target.closest(".wishlist_button");
    if (!button) return;

    const productId = button.getAttribute("data-product");
    const customerId = button.getAttribute("data-customer");
    const productHandle = button.getAttribute("data-productHandle");
    const page_type = button.getAttribute("data-pagetype");

    // Get sibling loader
    const removeAction = button.parentElement.querySelector("#wishlist-loader");

    if (!productId || !customerId) {
      const accountLink = button.getAttribute("data-link");
      if (accountLink) {
        window.location.href = accountLink;
      }
      console.error("Missing productId or customerId");
      return;
    }

    if (removeAction) {
      button.style.display = "none";
      removeAction.style.display = "block";
    }

    try {
      if (button.classList.contains("in")) {
        // Remove from wishlist
        const res = await fetch("https://apps.gemstonesforsale.com/wp-json/wishlist/v1/remove", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            customer_id: customerId,
            product_id: productId
          })
        });
        const data = await res.json();
        if (data.status === true) {
          button.classList.remove("in");
        }
      } else {
        // Add to wishlist
        const res = await fetch("https://apps.gemstonesforsale.com/wp-json/wishlist/v1/add", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            customer_id: customerId,
            product_id: productId,
            product_handle: productHandle
          })
        });
        const data = await res.json();
        if (data.status === true) {
          button.classList.add("in");
          console.log(page_type);
          if(page_type == 'collection_page'){
            add_data_layer(button);
          }else{
            add_product_data_layer(button);
          }
        }
      }
    } catch (error) {
      console.error("Wishlist API error:", error);
    }

    if (removeAction) {
      button.style.display = "flex";
      removeAction.style.display = "none";
    }
  });


  function add_data_layer(button){
    console.log(button);
    var el = button.closest(".grid__item");
    if (!el) return;

     // Detect platform
    var isMobile = window.matchMedia("(max-width: 768px)").matches;
    var platform = isMobile ? "m-web" : "d-web";

    var typeEl = el.querySelector(".product--info");
    var sizeEl = el.querySelector(".product-size");
    var priceEl = el.querySelector(".price-item--regular .money");
    var priceRaw = priceEl ? priceEl.getAttribute("original_price") : 0;
      var price = priceRaw ? parseFloat(priceRaw.replace(/[^0-9.]/g, '')) : 0;

    var item = {
        item_id: (typeEl && typeEl.dataset.sku) || el.dataset.id,
        item_name: el.dataset.title || "",
        affiliation: (typeEl && typeEl.dataset.origin) || "",
        coupon: "NA",
        discount: 0,
        index: parseInt(el.dataset.index) || 0,
        item_brand: "Gemstones For Sale",
        item_category: (typeEl && typeEl.dataset.type) || "",
        item_category2: (typeEl && typeEl.dataset.treatment) || "",
        item_list_id: el.getAttribute("parent-id") || "",
        item_list_name: el.getAttribute("parent-name") || "",
        item_variant: (sizeEl && sizeEl.dataset.size) || "",
        price: price,
        quantity: 1,
        listing_date : (typeEl && typeEl.dataset.publish) || ""
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });

    window.dataLayer.push({
        event: "add_to_wishlist_ce",
        page_type: "collection_page",
        platform: platform,
        total_qty : 1,
        user_id_event: window.GA_CONTEXT ? GA_CONTEXT.user_id : undefined,
        user_status: window.GA_CONTEXT ? GA_CONTEXT.user_status : "guest",
        ecommerce: {
        currency: "USD",
        value : price,
        items: [item]
        }
    });
  }

  //
  function add_product_data_layer(button){
    // window.datalayer
    // Ensure product page
    var productEl = document.querySelector(".gfs-specifications .product--info");
    if (!productEl) return;

    var sizeEl = document.querySelector(".gfs-spec-size-item");

    // Detect platform
    var isMobile = window.matchMedia("(max-width: 768px)").matches;
    var platform = isMobile ? "m-web" : "d-web";
    var priceEl = document.querySelector(".gfs-product-hero .price-item--regular .money");
    var priceRaw = priceEl ? priceEl.getAttribute("original_price") : 0;
      var price = priceRaw ? parseFloat(priceRaw.replace(/[^0-9.]/g, '')) : 0;

    var item = {
      item_id: productEl.dataset.sku || productEl.dataset.id,
      item_name: productEl.dataset.title || "",
      affiliation: productEl.dataset.origin || "",
      item_category: productEl.dataset.type || "",
      item_category2: productEl.dataset.treatment || "",
      item_variant: sizeEl ? sizeEl.dataset.size : "",
      item_list_id: productEl.getAttribute("parent-id") || "",
      item_list_name: productEl.getAttribute("parent-title") || "",
      price: price,
      quantity: 1,
      listing_date : (productEl && typeEl.dataset.publish) || ""
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });

    window.dataLayer.push({
      event: "add_to_wishlist_ce",
      page_type: "product_page",
       total_qty : 1,
      platform: platform,
      user_id_event: window.GA_CONTEXT?.user_id,
      user_status: window.GA_CONTEXT?.user_status || "guest",
      ecommerce: {
        currency: "USD",
        value : price,
        items: [item]
      }
    });
  }

});